import {
    Box,
    Button,
    CircularProgress,
    Grid /* Typography */,
    Modal,
    Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import ModalColocacion from './modalColocacion';
import { sendRequest } from '../../../../services/request';
import { DataGrid, esES, useGridApiRef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import DataGridTotalFooterColocacion from '../../../../components/utils-components/DataGrid/DataGridTotalFooter/DataGridTotalFooterColocacion';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import 'dayjs/locale/es';
import ModalDiario from './Diario/modalDiario';
import { PreReporteDiario } from './Diario';
import { DataGridStyle } from '../../../../styles/DataGridSytle';
import {
    MonetizationOn,
    Person,
    ReportGmailerrorred,
} from '@mui/icons-material';
import { formatterCOP, formatterPTY } from '../../../../utils/utils';

dayjs.extend(updateLocale);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.updateLocale('es', {
    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
        '_',
    ),
    monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
    weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
});

const Reportes = ({ pais }) => {
    const URL = process.env.REACT_APP_API_URL;
    const [divisiones, setDivisiones] = useState([]);
    const [reporteDataSemanal, setReporteDataSemanal] = useState(null);
    const [reporteDataDiario, setReporteDataDiario] = useState(null);
    const [columns, setColumns] = useState([]);
    const [totalesFooter, setTotalesFooter] = useState({
        totales: {},
    });
    const [campanaSelected, setCampanaSelected] = useState(null);
    const [divisionSelected, setDivisionSelected] = useState(null);
    const [tipoSelected, setTipoSelected] = useState(null);

    // Week Picker
    const [fecha, setFecha] = useState(null);
    const [hoveredDay, setHoveredDay] = useState(null);

    //Modales
    const [open, setOpen] = useState(false);
    const [openPreReporteColocacion, setOpenPreReporteColocacion] =
        useState(false);
    const [openPreReporteDiario, setOpenPreReporteDiario] = useState(false);

    const [loading, setLoading] = useState(false);
    const [isButtonSelected, setIsButtonSelected] = useState({
        diario: false,
        semanal: false,
    });
    const [columnWidths, setColumnWidths] = useState([]);

    const dataGridRef = useGridApiRef();

    let weekDays = [
        dayjs(fecha).locale('es').weekday(0),
        dayjs(fecha).locale('es').weekday(1),
        dayjs(fecha).locale('es').weekday(2),
        dayjs(fecha).locale('es').weekday(3),
        dayjs(fecha).locale('es').weekday(4),
        dayjs(fecha).locale('es').weekday(5),
        dayjs(fecha).locale('es').weekday(6),
    ];

    // Los pongo con la primera en mayúscula
    const weekDaysName = weekDays.map((day) => {
        day =
            day.format('dddd DD').charAt(0).toUpperCase() +
            day.format('dddd DD').slice(1);
        return day;
    });

    const weekMonthsName = weekDays.map((day) => {
        day =
            day.format('MMM DD').charAt(0).toUpperCase() +
            day.format('MMM DD').slice(1);
        return day;
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await sendRequest('get', `${URL}/${pais}/division`);
                setDivisiones(res.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [URL, pais]);

    const handleColocacionSemanal = () => {
        setOpen(true);
        setOpenPreReporteColocacion(true);
        setIsButtonSelected({
            semanal: true,
            diario: false,
        });
    };

    const handlePrereporteDiario = () => {
        setOpen(true);
        setOpenPreReporteDiario(true);
        setIsButtonSelected({
            diario: true,
            semanal: false,
        });
    };

    const handleClose = () => {
        setOpen(false);
        setOpenPreReporteDiario(false);
        setOpenPreReporteColocacion(false);
    };

    const handleContinuar = async (reporteType, dataReporte) => {
        setLoading(true);
        const { tipo, fecha, campana, division } = dataReporte;
        setDivisionSelected(division);
        setTipoSelected(tipo);
        let columns = [
            {
                field: 'first_day',
                renderHeader: () =>
                    division.id === 1 ? (
                        <Typography>{weekDaysName[0]}</Typography>
                    ) : (
                        <Person />
                    ),
                width: division.id === 1 ? 70 : 40,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    // Envios es si llega desde Colombia si no EnviosPanama
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 1
                        ) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_first_day',
                renderHeader: () => <MonetizationOn />,
                width: 90,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    // Envios es si llega desde Colombia si no EnviosPanama
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 1
                        ) {
                            donacion += envio.donacion_inicial;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'second_day',
                renderHeader: () =>
                    division.id === 1 ? (
                        <Typography>{weekDaysName[1]}</Typography>
                    ) : (
                        <Person />
                    ),
                width: division.id === 1 ? 70 : 40,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 2
                        ) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_second_day',
                renderHeader: () => <MonetizationOn />,
                width: 90,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 2
                        ) {
                            donacion += envio.donacion_inicial;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'third_day',
                renderHeader: () =>
                    division.id === 1 ? (
                        <Typography>{weekDaysName[2]}</Typography>
                    ) : (
                        <Person />
                    ),
                width: division.id === 1 ? 90 : 40,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 3
                        ) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_third_day',
                renderHeader: () => <MonetizationOn />,
                width: 90,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 3
                        ) {
                            donacion += envio.donacion_inicial;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'fourth_day',
                renderHeader: () =>
                    division.id === 1 ? (
                        <Typography>{weekDaysName[3]}</Typography>
                    ) : (
                        <Person />
                    ),
                width: division.id === 1 ? 75 : 40,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 4
                        ) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_fourth_day',
                renderHeader: () => <MonetizationOn />,
                width: 90,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 4
                        ) {
                            donacion += envio.donacion_inicial;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'fifth_day',
                renderHeader: () =>
                    division.id === 1 ? (
                        <Typography>{weekDaysName[4]}</Typography>
                    ) : (
                        <Person />
                    ),
                width: division.id === 1 ? 75 : 40,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 5
                        ) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_fifth_day',
                renderHeader: () => <MonetizationOn />,
                width: 90,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 5
                        ) {
                            donacion += envio.donacion_inicial;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'sixth_day',
                renderHeader: () =>
                    division.id === 1 ? (
                        <Typography>{weekDaysName[5]}</Typography>
                    ) : (
                        <Person />
                    ),
                width: division.id === 1 ? 77 : 40,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 6
                        ) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_sixth_day',
                renderHeader: () => <MonetizationOn />,
                width: 90,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 6
                        ) {
                            donacion += envio.donacion_inicial;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'seventh_day',
                renderHeader: () =>
                    division.id === 1 ? (
                        <Typography>{weekDaysName[6]}</Typography>
                    ) : (
                        <Person />
                    ),
                width: division.id === 1 ? 85 : 40,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 0
                        ) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_seventh_day',
                renderHeader: () => <MonetizationOn />,
                width: 90,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                                dayjs(fecha).week() &&
                            dayjs(envio.created_at).day() === 0
                        ) {
                            donacion += envio.donacion_inicial;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'total_semana',
                renderHeader: () => {
                    if (division.id === 1) {
                        return (
                            <Typography fontWeight="bold" variant="body1">
                                Producción Venta
                            </Typography>
                        );
                    }
                    return (
                        <Typography fontWeight="bold" variant="body1">
                            Don.
                        </Typography>
                    );
                    // return <PersonAddAlt1 />;
                },
                width: division.id === 1 ? 85 : 55,
                headerClassName: 'header-totales',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            dayjs(envio.created_at).week() ===
                            dayjs(fecha).week()
                        )
                            cantidad += envio.cantidad;
                    }
                    return <b>{cantidad}</b>;
                },
            },
            {
                field: 'donacion_total_semana',
                renderHeader: () => {
                    // return <AddBusiness />;
                    return (
                        <Typography fontWeight="bold" variant="body1">
                            Recaudo
                        </Typography>
                    );
                },
                width: 90,
                headerClassName: 'header-totales',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        // Me garantiza que el envio se realizo en la misma semana que la fecha seleccionada
                        if (
                            dayjs(envio.created_at).week() ===
                            dayjs(fecha).week()
                        )
                            donacion += envio.donacion_inicial;
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'total_semana_verificado',
                renderHeader: () => {
                    if (division.id === 1) {
                        return (
                            <Typography fontWeight="bold" variant="body1">
                                Producción Venta Verificado
                            </Typography>
                        );
                    }
                    // return <HowToReg />;
                    return (
                        <Typography fontWeight="bold" variant="body1">
                            Don. Ver.
                        </Typography>
                    );
                },
                width: division.id === 1 ? 85 : 55,
                headerClassName: 'header-totales',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        // Busco todos los envios confirmados y garantizo que la fecha de cierre este en la misma semana seleccionada
                        if (
                            envio.estado?.id === 9 &&
                            dayjs(envio?.fecha_cierre).week() ===
                                dayjs(fecha).week()
                        )
                            cantidad += envio.cantidad;
                    }
                    return <b>{cantidad}</b>;
                },
            },
            {
                field: 'donacion_total_semana_verificado',
                renderHeader: () => {
                    // return <PriceCheck />;
                    return (
                        <Typography fontWeight="bold" variant="body1">
                            Recaudo Ver.
                        </Typography>
                    );
                },
                width: 90,
                headerClassName: 'header-totales',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        // Busco todos los envios confirmados y garantizo que la fecha de cierre este en la misma semana seleccionada
                        if (
                            envio.estado?.id === 9 &&
                            dayjs(envio?.fecha_cierre).week() ===
                                dayjs(fecha).week()
                        )
                            donacion += envio.donacion_total;
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'porcentaje_recaudo',
                renderHeader: () => {
                    // return <Percent />;
                    return (
                        <Typography fontWeight="bold" variant="body1">
                            % Efect.
                        </Typography>
                    );
                },
                // flex: 0.5,
                width: 65,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let sumaDonacionFinal = 0;
                    let sumaDonacionInicial = 0;
                    let porcentaje = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (
                            envio.estado?.id === 9 &&
                            dayjs(envio?.fecha_cierre).week() ===
                                dayjs(fecha).week()
                        )
                            sumaDonacionFinal += envio.donacion_total;
                        if (
                            dayjs(envio.created_at).week() ===
                            dayjs(fecha).week()
                        )
                            sumaDonacionInicial += envio.donacion_inicial;
                    }
                    porcentaje =
                        (sumaDonacionFinal / sumaDonacionInicial) * 100;
                    return `${porcentaje.toFixed(2)}%`;
                },
            },
        ];

        // Quito todos las donaciones si seleccionaron publicidad
        if (division.id === 1) {
            columns = columns.filter(
                (column) => !column.field.includes('donacion_'),
            );
        }

        switch (reporteType) {
            case 'colocacion_semanal':
                let res;
                if (tipo && tipo?.nombre === 'Promotor') {
                    res = await sendRequest(
                        'get',
                        `${URL}/${pais}/envio/colocacion/semanal?campana=${
                            campana.id
                        }&semana=${dayjs(fecha).week()}&division=${
                            division.id
                        }`,
                    );
                    setColumns([
                        {
                            field: 'codigo',
                            headerName: 'Código',
                            //flex: 'auto',
                            width: 63,
                            headerClassName: 'header',
                            headerAlign: 'center',
                            align: 'center',
                            sortable: false,
                        },
                        {
                            field: 'promotor',
                            headerName: 'Promotor',
                            // flex: 0.5,
                            width: 100,
                            headerClassName: 'header',
                            headerAlign: 'center',
                            align: 'center',
                            sortable: false,
                            renderCell: ({ row }) =>
                                `${row.nombres} ${row.apellidos}`,
                        },
                        ...columns,
                    ]);
                }
                if (tipo && tipo?.nombre === 'Campaña') {
                    res = await sendRequest(
                        'get',
                        `${URL}/${pais}/campana/colocacion-semanal?semana=${dayjs(
                            fecha,
                        ).week()}&division=${division.id}`,
                    );
                    setColumns([
                        {
                            field: 'campana',
                            headerName: 'Nombre Campaña',
                            width: 180,
                            // flex: 0.8,
                            headerClassName: 'header',
                            aling: 'center',
                            sortable: false,
                            valueGetter: ({ row }) => `${row.nombre}`,
                        },
                        ...columns,
                    ]);
                }
                handleClose();
                setCampanaSelected(campana);
                setLoading(false);
                setReporteDataSemanal(res?.data || []);
                calculaTotales(res?.data || []);
                setReporteDataDiario(null);
                break;
            case 'pre-reporte_diario':
                const resDiario = await sendRequest(
                    'get',
                    `${URL}/${pais}/envio/colocacion/diaria?division=${
                        division?.id
                    }&fecha=${dayjs(fecha).format('YYYY-MM-DD')}`,
                );
                setFecha(fecha);
                setReporteDataDiario(resDiario.data);
                setReporteDataSemanal(null);
                handleClose();
                setLoading(false);
                break;
            default:
                break;
        }
    };

    const calculaTotales = (data) => {
        let totales = {
            lunes: {
                cantidad_inicial: 0,
                cantidad_final: 0,
                donacion_inicial: 0,
                donacion_final: 0,
            },
            martes: {
                cantidad_inicial: 0,
                cantidad_final: 0,
                donacion_inicial: 0,
                donacion_final: 0,
            },
            miercoles: {
                cantidad_inicial: 0,
                cantidad_final: 0,
                donacion_inicial: 0,
                donacion_final: 0,
            },
            jueves: {
                cantidad_inicial: 0,
                cantidad_final: 0,
                donacion_inicial: 0,
                donacion_final: 0,
            },
            viernes: {
                cantidad_inicial: 0,
                cantidad_final: 0,
                donacion_inicial: 0,
                donacion_final: 0,
            },
            sabado: {
                cantidad_inicial: 0,
                cantidad_final: 0,
                donacion_inicial: 0,
                donacion_final: 0,
            },
            domingo: {
                cantidad_inicial: 0,
                cantidad_final: 0,
                donacion_inicial: 0,
                donacion_final: 0,
            },
            total_semana: {
                cantidad: 0,
                donacion: 0,
            },
            total_semana_verificado: {
                cantidad: 0,
                donacion: 0,
            },
        };
        // TO-DO: terminar de arreglar cantidad_final
        for (const row of data) {
            for (const envio of row.envios || row.enviosPanama) {
                if (dayjs(envio.created_at).week() === dayjs(fecha).week()) {
                    switch (dayjs(envio.created_at).day()) {
                        case 1:
                            totales.lunes.cantidad_inicial += envio.cantidad;
                            totales.lunes.cantidad_final += envio.cantidad;
                            totales.lunes.donacion_inicial +=
                                envio.donacion_inicial;
                            totales.lunes.donacion_final +=
                                envio.donacion_total;
                            break;
                        case 2:
                            totales.martes.cantidad_inicial += envio.cantidad;
                            totales.martes.cantidad_final += envio.cantidad;
                            totales.martes.donacion_inicial +=
                                envio.donacion_inicial;
                            totales.martes.donacion_final +=
                                envio.donacion_total;
                            break;
                        case 3:
                            totales.miercoles.cantidad_inicial +=
                                envio.cantidad;
                            totales.miercoles.cantidad_final += envio.cantidad;
                            totales.miercoles.donacion_inicial +=
                                envio.donacion_inicial;
                            totales.miercoles.donacion_final +=
                                envio.donacion_total;
                            break;
                        case 4:
                            totales.jueves.cantidad_inicial += envio.cantidad;
                            totales.jueves.cantidad_final += envio.cantidad;
                            totales.jueves.donacion_inicial +=
                                envio.donacion_inicial;
                            totales.jueves.donacion_final +=
                                envio.donacion_total;
                            break;
                        case 5:
                            totales.viernes.cantidad_inicial += envio.cantidad;
                            totales.viernes.cantidad_final += envio.cantidad;
                            totales.viernes.donacion_inicial +=
                                envio.donacion_inicial;
                            totales.viernes.donacion_final +=
                                envio.donacion_total;
                            break;
                        case 6:
                            totales.sabado.cantidad_inicial += envio.cantidad;
                            totales.sabado.cantidad_final += envio.cantidad;
                            totales.sabado.donacion_inicial +=
                                envio.donacion_inicial;
                            totales.sabado.donacion_final +=
                                envio.donacion_total;
                            break;
                        default:
                            totales.domingo.cantidad_inicial += envio.cantidad;
                            totales.domingo.cantidad_final += envio.cantidad;
                            totales.domingo.donacion_inicial +=
                                envio.donacion_inicial;
                            totales.domingo.donacion_final +=
                                envio.donacion_total;
                            break;
                    }
                }

                // Calculo el total de la semana verificado
                if (
                    envio.estado?.id === 9 &&
                    dayjs(envio?.fecha_cierre).week() === dayjs(fecha).week()
                ) {
                    totales.total_semana_verificado.cantidad += envio.cantidad;
                    totales.total_semana_verificado.donacion +=
                        envio.donacion_total;
                }
            }
        }
        totales.total_semana.cantidad =
            totales.lunes.cantidad_inicial +
            totales.martes.cantidad_inicial +
            totales.miercoles.cantidad_inicial +
            totales.jueves.cantidad_inicial +
            totales.viernes.cantidad_inicial +
            totales.sabado.cantidad_inicial +
            totales.domingo.cantidad_inicial;

        totales.total_semana.donacion =
            totales.lunes.donacion_inicial +
            totales.martes.donacion_inicial +
            totales.miercoles.donacion_inicial +
            totales.jueves.donacion_inicial +
            totales.viernes.donacion_inicial +
            totales.sabado.donacion_inicial +
            totales.domingo.donacion_inicial;

        setTotalesFooter({
            ...totales,
        });
    };

    const columnGrouping = [
        {
            groupId: 'first_column',
            headerName: '',
            headerClassName: 'groups',
            children: [
                { field: 'campana' },
                { field: 'codigo' },
                { field: 'promotor' },
            ],
        },
        {
            groupId: 'first_day',
            headerName: `${weekDaysName[0]}`,
            headerClassName: 'groups',
            children: [{ field: 'first_day' }, { field: 'donacion_first_day' }],
        },
        {
            groupId: 'second_day',
            headerName: `${weekDaysName[1]}`,
            headerClassName: 'groups',
            children: [
                { field: 'second_day' },
                { field: 'donacion_second_day' },
            ],
        },
        {
            groupId: 'third_day',
            headerName: `${weekDaysName[2]}`,
            headerClassName: 'groups',
            children: [{ field: 'third_day' }, { field: 'donacion_third_day' }],
        },
        {
            groupId: 'fourth_day',
            headerName: `${weekDaysName[3]}`,
            headerClassName: 'groups',
            children: [
                { field: 'fourth_day' },
                { field: 'donacion_fourth_day' },
            ],
        },
        {
            groupId: 'fifth_day',
            headerName: `${weekDaysName[4]}`,
            headerClassName: 'groups',
            children: [{ field: 'fifth_day' }, { field: 'donacion_fifth_day' }],
        },
        {
            groupId: 'sixth_day',
            headerName: `${weekDaysName[5]}`,
            headerClassName: 'groups',
            children: [{ field: 'sixth_day' }, { field: 'donacion_sixth_day' }],
        },
        {
            groupId: 'seventh_day',
            headerName: `${weekDaysName[6]}`,
            headerClassName: 'groups',
            children: [
                { field: 'seventh_day' },
                { field: 'donacion_seventh_day' },
            ],
        },
        {
            groupId: 'totales',
            headerName: 'Total',
            headerClassName: 'group-totales',
            renderHeaderGroup: () => {
                return (
                    <Typography
                        fontWeight="bold"
                        variant="body1"
                        sx={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                        }}
                    >
                        Total
                    </Typography>
                );
            },
            children: [
                { field: 'total_semana' },
                { field: 'donacion_total_semana' },
                { field: 'total_semana_verificado' },
                { field: 'donacion_total_semana_verificado' },
            ],
        },
    ];

    const mapTotalesToFields = (totales) => {
        const result = {
            first_day: totales.lunes?.cantidad_final ?? '',
            donacion_first_day: totales.lunes?.donacion_inicial ?? '',

            second_day: totales.martes?.cantidad_final ?? '',
            donacion_second_day: totales.martes?.donacion_inicial ?? '',

            third_day: totales.miercoles?.cantidad_final ?? '',
            donacion_third_day: totales.miercoles?.donacion_inicial ?? '',

            fourth_day: totales.jueves?.cantidad_final ?? '',
            donacion_fourth_day: totales.jueves?.donacion_inicial ?? '',

            fifth_day: totales.viernes?.cantidad_final ?? '',
            donacion_fifth_day: totales.viernes?.donacion_inicial ?? '',

            sixth_day: totales.sabado?.cantidad_final ?? '',
            donacion_sixth_day: totales.sabado?.donacion_inicial ?? '',

            seventh_day: totales.domingo?.cantidad_final ?? '',
            donacion_seventh_day: totales.domingo?.donacion_inicial ?? '',

            total_semana: totales.total_semana?.cantidad ?? '',
            donacion_total_semana: totales.total_semana?.donacion ?? '',

            total_semana_verificado:
                totales.total_semana_verificado?.cantidad ?? '',
            donacion_total_semana_verificado:
                totales.total_semana_verificado?.donacion ?? '',
        };

        return result;
    };

    useEffect(() => {
        setColumnWidths(
            columns.map((col) => {
                return (
                    dataGridRef.current?.getColumn(col.field)?.computedWidth -
                    0.8
                );
            }),
        );
    }, [columns, dataGridRef, reporteDataSemanal]);

    return (
        <>
            <Grid container>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} sm={2} mt={5} mx={5}>
                        <Button
                            variant="contained"
                            fullWidth
                            style={{ textTransform: 'none' }}
                            color={
                                isButtonSelected.diario
                                    ? 'publicidad'
                                    : 'primary'
                            }
                            onClick={handlePrereporteDiario}
                        >
                            Pre-reporte Diario
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} mt={5} mx={5}>
                        <Button
                            variant="contained"
                            fullWidth
                            color={
                                isButtonSelected.semanal
                                    ? 'publicidad'
                                    : 'primary'
                            }
                            style={{ textTransform: 'none' }}
                            onClick={handleColocacionSemanal}
                        >
                            Cierre Colocación Semanal
                        </Button>
                    </Grid>
                </Grid>
                {loading && (
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        pt={10}
                    >
                        <CircularProgress />
                    </Grid>
                )}
                {(reporteDataSemanal?.length === 0 ||
                    (reporteDataDiario?.f2f?.items.length === 0 &&
                        reporteDataDiario?.tmk?.items.length === 0 &&
                        reporteDataDiario?.tmk_f2f?.items.length === 0)) && (
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        pt={3}
                    >
                        <Grid item xs={12} fontSize={80}>
                            <ReportGmailerrorred
                                color="primary"
                                fontSize="xl"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h4">
                                No se encontraron resultados de la busqueda
                            </Typography>
                        </Grid>
                    </Grid>
                )}
                {reporteDataSemanal?.length > 0 && (
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} mt={5}>
                            <Typography variant="h4" color="primary">
                                Colocación Semanal Por {tipoSelected?.nombre}{' '}
                                {campanaSelected
                                    ? ` - ${campanaSelected?.nombre}`
                                    : ''}{' '}
                                - {divisionSelected?.nombre}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h5" color="primary">
                                Semana {dayjs(fecha).week()}
                            </Typography>
                            <Typography variant="h5" color="primary">
                                {weekMonthsName[0]} - {weekMonthsName[6]}
                            </Typography>
                        </Grid>

                        <Box
                            sx={
                                {
                                    /* overflowX: 'auto' */
                                }
                            }
                        >
                            <Box
                                sx={{
                                    width: 'fit-content',
                                }}
                            >
                                <DataGrid
                                    apiRef={dataGridRef}
                                    experimentalFeatures={{
                                        columnGrouping: true,
                                    }}
                                    localeText={
                                        esES.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    disableColumnSelector
                                    disableDensitySelector
                                    disableColumnFilter
                                    disableColumnMenu
                                    disableRowSelectionOnClick
                                    hideFooterPagination
                                    columns={columns}
                                    rows={reporteDataSemanal}
                                    loading={loading}
                                    slots={{
                                        footer: () => (
                                            <DataGridTotalFooterColocacion
                                                columns={columns}
                                                columnWidths={columnWidths}
                                                totalRow={mapTotalesToFields(
                                                    totalesFooter,
                                                )}
                                            />
                                        ),
                                    }}
                                    getRowHeight={() => 40}
                                    sx={[
                                        DataGridStyle,
                                        {
                                            '& .groups': {
                                                backgroundColor: 'primary.main',
                                                color: 'white',
                                                borderBottom: '1px solid white',
                                            },
                                            '& .header-totales': {
                                                backgroundColor:
                                                    'publicidad.main',
                                                color: '#000000',
                                                borderColor: 'primary.main',
                                            },
                                            '& .group-totales': {
                                                borderBottom: '1px solid',
                                                borderBottomColor:
                                                    'primary.main',
                                                backgroundColor:
                                                    'publicidad.main',
                                                color: 'black',
                                            },
                                        },
                                    ]}
                                    columnGroupingModel={
                                        divisionSelected.id === 2
                                            ? columnGrouping
                                            : []
                                    }
                                />
                            </Box>
                        </Box>
                    </Grid>
                )}
                {reporteDataDiario &&
                    (reporteDataDiario?.f2f?.items.length !== 0 ||
                        reporteDataDiario?.tmk?.items.length !== 0 ||
                        reporteDataDiario?.tmk_f2f?.items.length !== 0) && (
                        <PreReporteDiario
                            pais={pais}
                            data={reporteDataDiario}
                            divisionSelected={divisionSelected}
                            fechaSelected={fecha}
                        />
                    )}
            </Grid>
            <Modal open={open} onClose={handleClose}>
                <>
                    {openPreReporteColocacion && (
                        <ModalColocacion
                            URL={URL}
                            pais={pais}
                            divisiones={divisiones}
                            handleClose={handleClose}
                            handleContinuar={handleContinuar}
                            fecha={fecha}
                            setFecha={setFecha}
                            hoveredDay={hoveredDay}
                            setHoveredDay={setHoveredDay}
                        />
                    )}
                    {openPreReporteDiario && (
                        <ModalDiario
                            URL={URL}
                            pais={pais}
                            divisiones={divisiones}
                            handleClose={handleClose}
                            handleContinuar={handleContinuar}
                            fecha={fecha}
                            setFecha={setFecha}
                        />
                    )}
                </>
            </Modal>
        </>
    );
};

export default Reportes;
